<template>
    <router-view/>
</template>

<script>
export default {
    name: 'CadastrosWrapper'
}
</script>